<svelte:options accessors/>
<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import PagosCartItem from "./PagosCartItem.svelte";
    import {getFormatter} from "../../utils";
    import PagoAppSummaryBar from "./PagoAppSummaryBar.svelte";
    import {httpRequest, debounce} from "../../utils";
    import {createEventDispatcher, onMount} from "svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";

    const formatter = getFormatter();
    const dispatch = createEventDispatcher();

    export let data = [];
    export let total = 0;
    let link = '';
    let email = '';
    let form: any;

    let refereciasDePago = [];

    onMount(() => {
        for (const item of data) {
            refereciasDePago = [...refereciasDePago, ...item.referencias];
            total = total + item.valor;
        }
    })

    function getPaymentLink() {
        link = '';
        if (refereciasDePago.length < 1) {
            return;
        }
        if (form.checkValidity()) {

            let ref = window.open('', '_blank');
            ref.document.body.innerText = 'Cargando enlace, espera por favor...';
            httpRequest({
                method: 'post',
                data: {referencias: refereciasDePago, email: email}
            })
                .then(res => res.json())
                .then(data => {
                    link = data.url;
                    ref.location.href = link;
                });
        } else {
            form.reportValidity();
        }
    }


</script>
<section class="py-15 m:py-1 back-gray cart">
    <div class="container">
        <div class="grid-3-1 m:block m:gap-0 gap-2">
            <div>
                {#each data as item (item.itemId)}
                    <PagosCartItem data="{item}"/>
                {/each}
            </div>
            <div>
                <div class="summary-wrapper py-1 px-15 radius back-white min-w-300px">
                    <h2 style="font-weight: 400">Total</h2>
                    <div class="my-2">
                        <p><strong>Total a pagar {formatter(total)}</strong></p>
                    </div>
                    <div class="max-w-200px mx-auto">
                        <div class="box mb-1">
                            <form bind:this={form}>
                                <NauiInput bind:value={email} label="Ingresa tu email" type="email" required/>
                            </form>
                        </div>
                        <div class="box mb-1">
                            <NauiButton className="w-100" caption="Continuar a pago" color="accent"
                                        mode="solid" on:click={getPaymentLink} target="_blank"/>
                        </div>
                        <div class="box">
                            <NauiButton className="w-100" caption="Editar pagos" color="accent" mode="outline"
                                        on:click={() => {dispatch('back')}}/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<style>
    .summary-wrapper {
        position: sticky;
        top: calc(60px + 1rem);
    }

    @media (max-width: 1024px) {
        .cart {
            margin-bottom: 60px;
        }
    }

</style>
